<div>
  <div class="pure-menu pure-menu-horizontal">
    <a href="" onClick="return false;" class="pure-menu-heading pure-menu-link">Transit Time Configuration</a>
  </div>
  <div class="container">

    <!-- Scope selection: From Country Code -> Business Use Case -> Submit -->
    <form [formGroup]="transitTimeConfigurationForm" class="pure-form pure-form-stacked" (ngSubmit)="render()">

      <div class="pure-control-group">
        <label for="fromCountryCodeId">From Country Code <app-popover [message]="help_messages.from_country_code"></app-popover></label>
        <select id="fromCountryCodeId" class="pure-input-2-3"
                formControlName="fromCountryCode" (change)="onFromCountryCodeChange(fromCountryCodeRef.value)" #fromCountryCodeRef>
          <option *ngFor="let _fromCountryCode of fromCountryCodeOptions; let i = index"
                  [value]="_fromCountryCode">
            {{ _fromCountryCode }}
          </option>
        </select>
      </div>

      <div class="pure-control-group">
        <label for="businessUseCase">Business Use Case <app-popover [message]="help_messages.business_unit"></app-popover></label>
        <select name="businessUseCase" id="businessUseCase" class="pure-input-2-3" formControlName="businessUseCase" #businessUseCaseRef (change)="onBusinessUseCaseChange(businessUseCaseRef.value)">
          <ng-template ngFor let-item [ngForOf]="getItems">
            <optgroup label="{{item.name}}">
              <option *ngFor="let usecase of item.usecases" [value]="usecase.value">
                {{usecase.text}}
              </option>
            </optgroup>
          </ng-template>
        </select>
      </div>

      <div>
        <button class="pure-button pure-button-primary button-large" type="submit"
                [disabled]="transitTimeConfigurationForm.invalid || loading">
          Submit
        </button>
      </div>
    </form>

    <!-- Table of configuration records for the selected business unit -->
    <div *ngIf="transitTimeConfigurations.length != 0 && !loading">
      <table class="pure-table pure-table-horizontal">
        <thead>
        <tr>
          <th>Business Unit</th>
          <th>From Country Code</th>
          <th>Level Of Data</th>
          <th>Transit Time Type</th>
          <th>Mapped Services</th>
          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let _row of transitTimeConfigurations">
          <td>{{ _row.businessUnit || "N/A" }}</td>
          <td>{{ _row.fromCountryCode || "N/A" }}</td>
          <td>{{ _row.componentKeyValue || "N/A" }}</td>
          <td>{{ _row.transitTimeType || "N/A" }}</td>
          <td>{{ getMappedServicesDisplay(_row) }}</td>
          <td>
            <button class="pure-button button-small pure-button-primary" type="button" (click)="openEditDialog(_row)">
              Edit
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Empty state after a submit returns no records -->
    <div *ngIf="transitTimeConfigurations.length == 0 && !loading && !firstLoad">
      <h2>There are no onboarded transit time configuration records for the selected business unit.</h2>
    </div>

    <app-loader [loading]="loading" [size]="'small'"></app-loader>
  </div>
</div>
